var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('a',{class:_vm.tabClassName(tab),attrs:{"href":tab.href}},[_vm._v("\n    "+_vm._s(_vm.I18n.t(("top_tabs." + (tab.code))))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }